import type { Person } from "@/types/media";

export const people: Person[] = [
  {
    id: "p-01",
    name: "沈砚",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20Chinese%20male%20actor%20in%20his%20thirties%2C%20calm%20confident%20expression%2C%20plain%20warm%20grey%20seamless%20background%2C%20soft%20cinematic%20key%20light%2C%20shallow%20depth%20of%20field%2C%20clean%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-p01&orientation=squarish",
    bio: "实力派男演员，擅长塑造克制而有力量的角色，代表作涵盖科幻、悬疑与都市题材。",
  },
  {
    id: "p-02",
    name: "林知夏",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20Chinese%20female%20actress%20in%20her%20early%20thirties%2C%20gentle%20warm%20smile%2C%20plain%20warm%20grey%20seamless%20background%2C%20soft%20cinematic%20lighting%2C%20shallow%20depth%20of%20field%2C%20elegant%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-p02&orientation=squarish",
    bio: "著名女演员，表演细腻自然，多次获得表演类奖项提名。",
  },
  {
    id: "p-03",
    name: "周牧",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20Chinese%20male%20actor%20in%20his%20twenties%2C%20bright%20youthful%20expression%2C%20plain%20warm%20grey%20seamless%20background%2C%20soft%20cinematic%20key%20light%2C%20shallow%20depth%20of%20field%2C%20modern%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-p03&orientation=squarish",
    bio: "新生代男演员，凭借青春题材作品受到广泛关注，戏路宽广。",
  },
  {
    id: "p-04",
    name: "陆离",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20mature%20Chinese%20male%20actor%20with%20grey%20hair%20in%20his%20fifties%2C%20wise%20serene%20expression%2C%20plain%20warm%20grey%20seamless%20background%2C%20soft%20cinematic%20lighting%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-p04&orientation=squarish",
    bio: "资深表演艺术家，塑造过众多令人印象深刻的父辈与长者形象。",
  },
  {
    id: "p-05",
    name: "顾清晏",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20an%20elegant%20Chinese%20female%20actress%20in%20her%20late%20twenties%2C%20poised%20subtle%20expression%2C%20plain%20warm%20grey%20seamless%20background%2C%20soft%20cinematic%20lighting%2C%20shallow%20depth%20of%20field%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-p05&orientation=squarish",
    bio: "气质女演员，擅长诠释多层次内心戏，作品横跨电影与剧集。",
  },
  {
    id: "p-06",
    name: "江屿",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20Chinese%20male%20actor%20with%20short%20beard%20in%20his%20forties%2C%20serious%20determined%20expression%2C%20plain%20warm%20grey%20seamless%20background%2C%20soft%20cinematic%20lighting%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-p06&orientation=squarish",
    bio: "硬汉型男演员，常出演刑警、侦探等正义角色，气场强烈。",
  },
  {
    id: "p-07",
    name: "苏念",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20young%20Chinese%20female%20actress%20in%20her%20twenties%2C%20kind%20natural%20smile%2C%20plain%20warm%20grey%20seamless%20background%2C%20soft%20cinematic%20lighting%2C%20shallow%20depth%20of%20field%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-p07&orientation=squarish",
    bio: "人气女演员，亲和力十足，出演的都市与家庭题材作品广受喜爱。",
  },
  {
    id: "p-08",
    name: "程野",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20an%20athletic%20Chinese%20male%20actor%20in%20his%20thirties%2C%20rugged%20adventurous%20expression%2C%20plain%20warm%20grey%20seamless%20background%2C%20soft%20cinematic%20lighting%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-p08&orientation=squarish",
    bio: "动作与冒险题材常客，身体力行完成大量实拍动作场面。",
  },
  {
    id: "p-09",
    name: "韩雪岚",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20sharp%20intelligent%20Chinese%20female%20actress%20in%20her%20thirties%2C%20focused%20expression%2C%20plain%20warm%20grey%20seamless%20background%2C%20soft%20cinematic%20lighting%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-p09&orientation=squarish",
    bio: "以冷峻干练的银幕形象著称，常饰演专业领域的精英角色。",
  },
  {
    id: "p-10",
    name: "许知远",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20kind%20older%20Chinese%20male%20actor%20in%20his%20sixties%2C%20warm%20gentle%20expression%2C%20plain%20warm%20grey%20seamless%20background%2C%20soft%20cinematic%20lighting%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-p10&orientation=squarish",
    bio: "老戏骨，擅长演绎温厚质朴的父亲与长辈形象，是家庭题材的常青演员。",
  },
  {
    id: "p-11",
    name: "温故",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20thoughtful%20Chinese%20male%20actor%20in%20his%20late%20twenties%2C%20quiet%20artistic%20expression%2C%20plain%20warm%20grey%20seamless%20background%2C%20soft%20cinematic%20lighting%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-p11&orientation=squarish",
    bio: "文艺片常客，气质独特，兼有演员与导演身份。",
  },
  {
    id: "p-12",
    name: "秦朗",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20confident%20Chinese%20male%20actor%20in%20his%20thirties%2C%20commanding%20presence%20expression%2C%20plain%20warm%20grey%20seamless%20background%2C%20soft%20cinematic%20lighting%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-p12&orientation=squarish",
    bio: "兼具偶像外形与硬朗气质的男演员，动作与情感戏皆能驾驭。",
  },
];

export const getPerson = (id: string): Person | undefined =>
  people.find((person) => person.id === id);